module.exports = __webpack_public_path__ + "img/bookmark.52d188a0.svg";